/**
 * This class is responsible for copying the slug to the clipboard when the
 * button is clicked
 */
export default class ClipboardAssistant {
	/**
	 * The constructor for the ClipboardAssistant class.
	 *
	 * @param selector The selector for the elements that will have the click
	 *   event listener added.
	 */
	constructor(selector: string) {
		const elements = Array.from(document.querySelectorAll(selector));
		for (const element of elements) {
			element.addEventListener("click", (e) => {
				this.handleClick(e as MouseEvent);
			});
		}
	}

	/**
	 * Writes the text to the clipboard when the button is clicked.
	 *
	 * @param e The click event.
	 */
	handleClick(e: MouseEvent): void {
		const eventTarget = e.currentTarget as HTMLElement;
		writeText(wrapWithShortCode(eventTarget.textContent || ""));
	}
}

/**
 * Wraps the id with the shortcode to easily paste it into the editor.
 *
 * @param id The id to wrap with the shortcode.
 * @returns The shortcode with the id inserted.
 */
export function wrapWithShortCode(id: string): string {
	return `[rtml id="${id}"]`;
}

/**
 * Writes the text to the clipboard.
 *
 * @param toWriteToClipboard The text to write to the clipboard.
 * @returns A promise that resolves when the text is written to the clipboard.
 */
export async function writeText(toWriteToClipboard: string): Promise<void> {
	await navigator.clipboard.writeText(toWriteToClipboard);
}
